import { IUser } from '../../../shared/types/user';
import { ROLES } from '../../permissions/permissions';

export function isAdminOrModerator({roles}: IUser): boolean {
  return roles.some(role => role === ROLES.admin || role === ROLES.moderator);
}
